export const GET_SURVEY_RESULTS_REQUESTED = 'GET_SURVEY_RESULTS_REQUESTED'
export const GET_SURVEY_RESULTS_SUCCESS = 'GET_SURVEY_RESULTS_SUCCESS'
export const GET_SURVEY_RESULTS_FAILURE = 'GET_SURVEY_RESULTS_FAILURE'
